import {
  Required,
  IsString,
  IsNumber,
  IsBoolean,
  IsArray,
  ValidateNested,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

interface UsersTeamsResponse {
  message: string;
  teams: Array<{
    id: number;
    team_name: string;
    team_code: string;
    master_user_id: number;
    member_count: number;
    workspace_count: number;
    is_current_user_master: boolean;
  }>;
}

class Team {
  @Required("ID cannot be empty")
  @IsNumber("ID must be a number")
  id: number;

  @Required("Team name cannot be empty")
  @IsString("Team name must be a string")
  teamName: string;

  @Required("Team code cannot be empty")
  @IsString("Team code must be a string")
  teamCode: string;

  @Required("Master user id cannot be empty")
  @IsNumber("Master user id must be a number")
  masterUserId: number;

  @Required("Member count cannot be empty")
  @IsNumber("Member count must be a number")
  memberCount: number;

  @Required("Workspace count cannot be empty")
  @IsNumber("Workspace count must be a number")
  workspaceCount: number;

  @Required("isCurrentUserMaster cannot be empty")
  @IsBoolean("isCurrentUserMaster must be a boolean")
  isCurrentUserMaster: boolean;
}

export class UsersTeamsData {
  @Required("Message cannot be empty")
  @IsString("Message must be a string")
  message: string;

  @Required("Teams cannot be empty")
  @IsArray("Teams must be an array")
  @ValidateNested(Team)
  teams: Team[];
}

const transformAndValidateUsersTeams = (
  response: UsersTeamsResponse
): UsersTeamsData => {
  const transformedData = transformKeys(response);
  try {
    return DataValidator.validateOrThrow(transformedData, UsersTeamsData);
  } catch (error: any) {
    console.error("Users teams data validation failed:", error.message);
    throw error;
  }
};

export async function usersTeams(): Promise<UsersTeamsData> {
  const res = await api.get<UsersTeamsResponse>("/users/teams");
  const validatedData = transformAndValidateUsersTeams(res.data);
  return validatedData;
}